import React, { useEffect, useState } from "react";
import "../../dashboard/components/VendordashboardPage.css";
import { Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import catalog from "./../../../assets/catalogue.svg";
import { postRequestcall } from "../../comman/util/postRequest";
import { DELETE_PRODUCT, PRODUCT_LIST } from "../../constants/apiurl";
import "./ProductlistPage.css";
import { useTranslation } from "react-i18next";
import no_product from "../../../assets/no_product.svg";
import NodatafoundPage from "../../nodatafound/components/NodatafoundPage";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import plus from "../../../assets/plus.svg";
import { getRequestcall } from "../../comman/util/getRequest";
import PaginationPage from "../../comman/components/PaginationPage";
import { Product } from "../../comman/components/ProductCommonPage";
import SearchProductPage from "../../comman/components/SearchProductPage";
import { clearStoredetail } from "../../dashboard/redux/actions";
import { toast } from "react-toastify";
import { fetchLogindata } from "../../login/redux/actions";
const DeletepopupPage = React.lazy(() =>
  import("../../modal/components/DeletepopupPage")
);

function ProductlistPage(props) {

  const navigate = useNavigate();
  const { t } = useTranslation();
  const [deleteModal, setDeleteModal] = useState(false);
  const [productlist, setProductlist] = useState([]);
  const [deleteInfo, setDeleteinfo] = useState({
    title: t("pages.deletepop.product_delete"),
    sub_title: t("pages.deletepop.product_delete_subtitle"),
    name: "",
    id: "",
    type: t("pages.deletepop.product"),
  });
  const [searchproduct, setSearchproduct] = useState("");
  const [noproduct, setNoproduct] = useState();
  const [links, setLinks] = useState([]);
  const [paginationvalue, setPaginationvalue] = useState({
    total: 1,
    currentPage: 1,
  });
  const [storeApprove,setStoreapprove] = useState("");
  let getLastvalue = window.location.pathname.split("/").pop();

  // eslint-disable-next-line
  useEffect(() => {
    (async () => getProductlist(1, ""))();
  // eslint-disable-next-line
  }, [props.storeDetail.store_id]);

  useEffect(() => {
    setDeleteinfo({
      ...deleteInfo,
      title: t("pages.deletepop.product_delete"),
      sub_title: t("pages.deletepop.product_delete_subtitle"),
      name: "",
      id: "",
      type: t("pages.deletepop.product"),
    });
    // eslint-disable-next-line
  }, [props?.language]);

  const addProduct = () => {
    if(storeApprove === "") {
      navigate("/vendor/products/add");
    }else{
       toast.error(storeApprove);
    }
  };

  const searchValuechange = (e) => {
    e.preventDefault();
    setSearchproduct(e.target.value);
    getProductlist(1, e.target.value);
  };

  const getProductlist = async (page, search) => {
    props?.fetchHeaderContent(t("pages.sidenav.addproduct"), "", "");
    if (typeof props.storeDetail.store_id !== "undefined") {
      let url = PRODUCT_LIST +`/v2?store_id=${props.storeDetail.store_id}&page=${page}&service_id=${""}&search=${search}&for_users=no`;
      let getList = await getRequestcall(url, props?.access_token);
      if (getList?.status === 200) {
        setStoreapprove("");
        let products = await getList.json();
        if (products?.data?.productList?.data.length > 0) {
          setLinks(products?.data?.productList?.links);
          setPaginationvalue({
            total: products?.data?.productList?.total,
            currentPage: page,
          });
          setProductlist(products?.data?.productList?.data);
          setNoproduct(false);
        } else {
          setLinks([]);
          setNoproduct(true);
          setProductlist([]);
        }
      } else if (getList?.status === 400) {
        let getError = await getList.json();
        if (getError?.error?.is_deleted) {
          props?.clearStoredetail([]);
          props.logindata.type = "user";
          props.fetchLogindata(props.logindata);
          navigate("/vendor/");
        } else {
          if(getLastvalue !== "dashboard"){
            toast.error(getError?.errors);
          }
          setStoreapprove(getError?.errors);
          setLinks([]);
          setNoproduct(true);
          setProductlist([]);
        }
      }
    }
  };

  const productEdit = (pid) => {
    if(storeApprove === "") {
    navigate(`/vendor/products/${pid}`);
    }else{
      toast.error(storeApprove);
    }
  };

  const productDelete = (item) => {
    setDeleteinfo({
      ...deleteInfo,
      name: item.title,
      id: item.pid,
    });
    setDeleteModal(true);
  };

  const itemDelete = async () => {
    let url = DELETE_PRODUCT + `/${deleteInfo.id}`;
    let getRes = await postRequestcall(url, props.access_token, "");
    if (getRes?.status === 200) {
      getProductlist(1, "");
    }
  };

  const navigateToproductlist = () => {
    navigate(`/vendor/products`);
  };

  const getPaginationProductlist = async (page) => {
    if (typeof props.storeDetail.store_id !== "undefined") {
      getProductlist(page, searchproduct);
    }
  };

  const AddProductDiv = (props) => {
    return (
      <div className="col-6  p-2">
        <div className={props?.className} onClick={props.onClick}>
          {props?.type === "product" ?
            <div className="plus">
              <img src={plus} height="20" width="20" alt="add product"></img>
              <h5>{t("pages.products.add_product")}</h5>
            </div>
            :
            <div className="card-body">
              <img src={catalog} alt={"catalog"} />
              <h5 className="hover font-16 mb-0">
                {t("pages.products.browse_catalog")}
              </h5>
              <i className="icon_after arrow_right_icon" />
            </div>}
        </div>
      </div>
    )
  }

  const navigateCatalog = () => {
    if(storeApprove === "") {
    navigate("/vendor/products/catalog");
    }else{
      toast.error(storeApprove);
    }
  }

  return (
    <>
      <div className={props.maincontent ? "col-xl-9 main-content" : ""}>
        <div>
          <div className="d-flex align-center justify-content-between align-items-start">
            <label className="recently">
              {props.maincontent
                ? t("pages.products.title")
                : t("pages.products.recently_added")}
            </label>
            {props.maincontent === false && (
              <span className="view" onClick={() => navigateToproductlist()}>
                {t("pages.viewall")}
              </span>
            )}
          </div>
        </div>
        <Row className="mt-2 mb-3 store-product">
          <AddProductDiv
            onClick={() => addProduct()}
            className={"add-products"}
            type={"product"}
          />
          <AddProductDiv
            onClick={() => navigateCatalog()}
            className={"add_catalog card plus"}
            type={"browse"}
          />
          {(!noproduct || searchproduct !== "") && <SearchProductPage
            onChange={searchValuechange}
            value={searchproduct}
            placeholder={t("pages.storedetail.products.search-place")}
          />}
          {noproduct ? (
            <NodatafoundPage
              className={"col-xl-12 main-content prductlist-centent"}
              image={no_product}
              button={
                props.maincontent === false ? false : t("pages.backtodashboard")
              }
              title={t("pages.No products")}
              description={t("pages.No products found")}
              navigation={"/vendor/dashboard"}
            />
          ) : (
            productlist?.map((item, index) => (
              <div key={index.toString()} className="col-6 Comman_product ">
                <Product
                  item={item}
                  index={index}
                  is_productlist={true}
                  className={"is_productlist "} //Comman_product
                  productDelete={productDelete}
                  productEdit={productEdit}
                  innerClass={"innerProduct is_productlist"}
                  listType={"product"}
                  detailTab={"products"}
                />
              </div>
            ))
          )}
        </Row>
        {paginationvalue.total > 10 &&
          props.maincontent &&
          noproduct === false && (
            <PaginationPage
              changeCurrentpage={getPaginationProductlist}
              nopagination={noproduct}
              links={links}
            />
          )}
      </div>
      {deleteModal && (
        <DeletepopupPage
          setDeleteModal={setDeleteModal}
          deleteInfo={deleteInfo}
          deleteModal={deleteModal}
          itemDelete={itemDelete}
        ></DeletepopupPage>
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  storeDetail: state?.dashboard?.storeDetail,
  access_token: state?.login.access_token,
  language: state?.languageState?.language,
  
  logindata: state?.login?.logindata,
});

export default connect(mapStateToProps, { fetchHeaderContent, clearStoredetail, fetchLogindata })(
  ProductlistPage
);
